<template>
  <div>
    <b-form>
      <b-form-group label="Semester" label-class="control-label workload-course-label"
        :class="{ 'invalid-group': $v.form.termId.$error }">
        <b-form-select :options="terms" v-model="form.termId" value-field="termId"
          text-field="term.description"></b-form-select>
        <span v-if="$v.form.termId.$error" class="span-feedback invalid-feedback">
          Please select a semester.
        </span>
      </b-form-group>

      <b-form-group aria-describedby="number-of-classes-help" label="Number of Classes"
        label-class="control-label workload-course-label" :class="{ 'invalid-group': $v.form.numberOfClasses.$error }">
        <b-form-input v-model="form.numberOfClasses"
          :class="{ 'is-invalid': $v.form.numberOfClasses.$error }"></b-form-input>
        <b-form-text id="number-of-classes-help">
          A buyout request for more than 2 classes will require extra approvals.
        </b-form-text>
      </b-form-group>

      <!-- <b-form-group label="Buyout %" label-class="control-label workload-course-label" :class="{ 'invalid-group': $v.form.buyoutPercent.$error }">
        <b-form-input v-model="form.buyoutPercent" :class="{ 'is-invalid': $v.form.buyoutPercent.$error }"></b-form-input>
      </b-form-group> -->

      <b-form-group label="Notes" label-class="control-label workload-course-label">
        <b-form-textarea :rows="3" placeholder="Enter notes..." v-model="form.notes"></b-form-textarea>
      </b-form-group>

      <b-form-group label="Has this buyout been discussed with the appropriate program director?"
        v-slot="{ ariaDescribedby }">
        <b-form-radio-group id="radio-group-1" v-model="discussed" :options="[
          { text: 'Yes', value: true },
          { text: 'No', value: false },
        ]" :aria-describedby="ariaDescribedby" name="radio-options"></b-form-radio-group>
        <b-form-group aria-describedby="program-director-help-block" label="Program Director Name"
          label-class="control-label workload-course-label" :class="{ 'invalid-group': $v.form.programDirector.$error }">
          <b-form-input v-model="form.programDirector" :disabled="!discussed"
            :class="{ 'is-invalid': $v.form.programDirector.$error }"></b-form-input>
          <b-form-text id="program-director-help-block">
            This assures that the course scheduler has been notified of the need
            to identify a substitute instructor for the course in question.
            Also, approval is based on this discussion initiation .
          </b-form-text>
        </b-form-group>
      </b-form-group>

    </b-form>
    <b-form @submit.prevent="addGrant(grant)">
      <b-form-group aria-describedby="grantNumber-help"
        label=" Grant Number (GR), Award Number (AWD), or Funding Proposal Number (FP)"
        label-class="control-label workload-course-label" :class="{ 'invalid-group': $v.grant.$error }">
        <b-form-input v-model="grant.grantNumber" :class="{ 'is-invalid': $v.grant.$error }"></b-form-input>

        <b-form-text id="grantNumber-help">To obtain these numbers, please reference the document that you received during
          your Award Kick Off meeting or any other identifying information that you may have received regarding the
          funding.</b-form-text>

      </b-form-group>
      <b-button type="submit">Add to Request</b-button>
    </b-form>


    <div>
      <b-table striped hover small :fields="grantFields" :items="requestedGrants">
        <template v-slot:cell(grant)="data">
          {{ data.item.description }}
        </template>
        <template v-slot:cell(percentage)="data">
          {{ data.item.percentage }} %
        </template>
        <template v-slot:cell(controls)="data">
          <div class="text-right">
            <font-awesome-icon icon="times" class="remove-icon mx-1"
              @click.prevent="removeGrant(data.item)"></font-awesome-icon>
          </div>
        </template>

      </b-table>
    </div>

    <span v-if="$v.form.$error" class="span-feedback invalid-feedback">
      All fields must be filled out and you must have at least one funding source listed.
    </span>

  </div>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import { required, integer, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      discussed: false,
      grant: {
        grantNumber: null,
        grantPercentage: null
      },

      form: {
        id: 0,
        termId: null,
        numberOfClasses: null,
        term: {
          description: ""
        },
        notes: null,
        buyoutPercent: null,
        grants: [],
        programDirector: null
      },
      grantFields: [{ key: "grant", label: "" }, { key: "controls", label: "" }]
    };
  },

  props: {
    value: {
      type: Boolean,
      required: false
    },
    editingBuyout: {
      type: Object,
      required: false
    },
    terms: {
      type: Array,
      required: true
    }
  },

  computed: {
    requestedGrants() {
      return _.filter(this.form.grants, grant => {
        return grant.requested;
      });
    }
  },

  watch: {
    value: function () {
      if (this.value) {
        this.$v.form.$touch();
        if (!this.$v.form.$error) {
          this.$emit("complete", this.form);
          this.$v.$reset();
          this.form = {
            id: 0,
            notes: null,
            buyoutPercent: null,
            grants: []
          };
        } else {
          this.$emit("input", false);
        }
      }
    },
    editingBuyout: function () {
      if (this.editingBuyout) {
        this.setForm(this.editingBuyout);
      }
    }
  },

  validations() {
    var validations = {
      form: {},
      grant: { grantNumber: { required } }
    };
    if (this.discussed) {
      validations.form = {
        numberOfClasses: { required, integer },
        programDirector: { required },
        termId: { required },
        grants: {
          required,
          minLength: minLength(1),
          $each: {
            description: {
              required
            }
          }
        }
      };
    } else {
      validations.form = {
        numberOfClasses: { required, integer },
        programDirector: {},
        termId: { required },
        grants: { required, minLength: minLength(1) }
      };
    }
    return validations;
  },

  methods: {
    setForm: function (buyout) {
      // set values
      this.form = buyout;
    },
    addGrant(grant) {
      this.$v.grant.$touch();

      if (!this.$v.grant.$error) {
        this.form.grants.push({
          description: grant.grantNumber,
          requested: true
        });
        this.grant.grantNumber = null;
        this.$nextTick(() => {
          this.$v.grant.$reset();
        });
        //this.$v.grantNumber.$touch();
      }
    },
    removeGrant(grant) {
      var index = _.findIndex(this.form.grants, item => {
        return item.description === grant.description;
      });
      this.form.grants.splice(index, 1);
    }
  },

  created() {
    if (this.editingBuyout) {
      this.setForm(this.editingBuyout);
      if (this.editingBuyout.programDirector) {
        this.discussed = true;
      }
    }
  }
};
</script>

<style scoped></style>
